import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMixAndMatchDetail } from "src/models/Offers/MixAndMatch.models";

interface MixAndMatchDetailState {
  mixAndMatchesDetails: IMixAndMatchDetail[];
  mixAndMatchDetailToEdit: IMixAndMatchDetail | null;
}

const initialState: MixAndMatchDetailState = {
  mixAndMatchesDetails: [],
  mixAndMatchDetailToEdit: null,
};

const MixAndMatchDetailSlice = createSlice({
  name: "MixAndMatchDetail",
  initialState,
  reducers: {
    setMixAndMatchDetailList: (
      state,
      action: PayloadAction<IMixAndMatchDetail[]>
    ) => {
      state.mixAndMatchesDetails = action.payload;
    },
    concatListMixAndMatchDetail: (
      state: MixAndMatchDetailState,
      action: PayloadAction<IMixAndMatchDetail[]>
    ) => {
      state.mixAndMatchesDetails = [
        ...state.mixAndMatchesDetails.concat(action.payload),
      ];
    },
    setMixAndMatchDetailToEdit: (
      state,
      action: PayloadAction<IMixAndMatchDetail | null>
    ) => {
      state.mixAndMatchDetailToEdit = action.payload;
    },
    addMixAndMatchDetail: (
      state,
      action: PayloadAction<IMixAndMatchDetail>
    ) => {
      state.mixAndMatchesDetails.push(action.payload);
    },
    updateMixAndMatchDetail: (
      state,
      action: PayloadAction<IMixAndMatchDetail>
    ) => {
      let itemIndex = state.mixAndMatchesDetails.findIndex(
        item => item.mixAndMatchDetailId === action.payload.mixAndMatchDetailId
      );
      if (itemIndex !== -1)
        state.mixAndMatchesDetails[itemIndex] = action.payload;
    },
    deleteMixAndMatchDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.mixAndMatchesDetails.filter(
        item => item.mixAndMatchDetailId !== action.payload
      );
      state.mixAndMatchesDetails = newArray;
    },
  },
});

export const {
  setMixAndMatchDetailList,
  concatListMixAndMatchDetail,
  setMixAndMatchDetailToEdit,
  addMixAndMatchDetail,
  updateMixAndMatchDetail,
  deleteMixAndMatchDetail,
} = MixAndMatchDetailSlice.actions;

export default MixAndMatchDetailSlice.reducer;
